import React from "react";
var AccordionContext = React.createContext({
  openedItems: [],
  setOpenedItems: function setOpenedItems() {
    return null;
  },
  openElement: function openElement() {
    return null;
  },
  scrollToOpenedContent: !1
});
export default AccordionContext;